import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {
  useSalesManagers,
  useUpdateAccountSalesManager,
} from '../hooks/useSubscriptionManagers';
import type { AccountTableRow } from '../types';

const UNASSIGNED = '__unassigned__';

interface AccountManagerCellProps {
  account: Pick<AccountTableRow, 'id' | 'sales_manager_id' | 'sales_manager_name'>;
}

export function AccountManagerCell({ account }: AccountManagerCellProps) {
  const { data: salesManagers = [], isLoading: managersLoading } = useSalesManagers();
  const mutation = useUpdateAccountSalesManager(account.id);

  // Mirror the filter dropdown in accountsColumnFilters.tsx: only active
  // (non-former) account managers appear in the option list.
  const activeManagers = salesManagers.filter((m) => !m.isFormer);

  const currentValue = account.sales_manager_id || UNASSIGNED;
  const handleChange = (value: string) => {
    if (!value) return; // guard against Radix spurious ""
    const nextId = value === UNASSIGNED ? null : value;
    if ((nextId || null) === (account.sales_manager_id || null)) return;
    mutation.mutate(nextId);
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Select
        value={currentValue}
        onValueChange={handleChange}
        disabled={managersLoading || mutation.isPending}
      >
        <SelectTrigger
          aria-label="Account manager"
          className="h-7 w-full min-w-0 text-xs font-normal"
        >
          <SelectValue placeholder="—" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={UNASSIGNED}>—</SelectItem>
          {activeManagers.map((m) => (
            <SelectItem key={m.id} value={m.id}>
              {m.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
